export const types = {
    SET_GET_MEDIA: '[MEDIA] SET GET MEDIA',
    SET_GET_MEDIA_BY_ID: '[MEDIA] SET GET MEDIA BY ID'
}